module.exports = __webpack_public_path__ + "static/img/db3_pc.930821ac.jpg";